import { createSlice } from "@reduxjs/toolkit";
const initialValue = {
  source: null,
  destination: null,
  numberOfPassengers: 1,
  searchedPool: null,
  searchedPoolResults: [],
  myPooledCars: [],
  pooledCars: [],
};

const PoolingMapSlice = createSlice({
  name: "pooling",
  initialState: initialValue,
  reducers: {
    setSourceAddress: (state, action) => {
      return {
        ...state,
        source: action.payload,
      };
    },
    setDestinationAddress: (state, action) => {
      return {
        ...state,
        destination: action.payload,
      };
    },
    setPassengers: (state, action) => {
      return {
        ...state,
        numberOfPassengers: Number(action.payload.numberOfPassengers),
      };
    },
    setSearchedPool: (state, action) => {
      return {
        ...state,
        searchedPool: action.payload,
      };
    },
    setAllPooledCars: (state, action) => {
      return {
        ...state,
        pooledCars: action.payload,
      };
    },
    setMyPooledCars: (state, action) => {
      return {
        ...state,
        myPooledCars: action.payload,
      };
    },
    setSearchedPoolResults: (state, action) => {
      return {
        ...state,
        searchedPoolResults: action.payload,
      };
    },
    clearPoolingAddresses: (state, action) => {
      return {
        ...state,
        source: null,
        destination: null,
        numberOfPassengers: 1,
      };
    },
    clearSearchedPool: (state, action) => {
      return {
        ...state,
        searchedPool: null,
      };
    },
  },
});

const { reducer } = PoolingMapSlice;
export default reducer;
export const {
  setSourceAddress,
  setDestinationAddress,
  setPassengers,
  setSearchedPool,
  setAllPooledCars,
  setMyPooledCars,
  setSearchedPoolResults,
  clearPoolingAddresses,
  clearSearchedPool,
} = PoolingMapSlice.actions;
